import { createReducer, on } from "@ngrx/store";
import * as selectedVariablesActions from './selected-variables.actions';

export interface LatestToSModel {
  id: string;
  version: number;
}

export interface SelectedVariablesModel {
  animalId: string;
  latestToS: LatestToSModel | null;
}

export const initialSelectedVariables: SelectedVariablesModel = {
  animalId: '',
  latestToS: null
};

export const selectedVariablesReducer = createReducer(
  initialSelectedVariables,
  on(selectedVariablesActions.resetVariables, () => {
    localStorage.removeItem('selectedPetId');
    return {
    ...initialSelectedVariables
    };
  }),
  on(selectedVariablesActions.setAnimalId, (state, { animalId }) => {
    localStorage.setItem('selectedPetId', animalId);
    return {
      ...state,
      animalId
    }
  }),
  on(selectedVariablesActions.loadLatestToS, (state) => state),
  on(selectedVariablesActions.setLatestToS, (state, { latestToS }) => ({
    ...state,
    latestToS: latestToS
  }))
);
